export const SCHEDULE_TZ = 'America/New_York';
export const WINDOW_START_MIN = 510;
export const WINDOW_END_MIN = 30;
export const DAY_MIN = 1440;
export const FREQ_STEP_MIN = 10;
export const FREQ_MAX_MIN = 360;
export const MAX_SUBJECT_LEN = 120;
export const MAX_CLOCKED_TIMES = 96;

export const minuteInWindow = (m: number, start: number, end: number): boolean => {
  if (start <= end) return m >= start && m <= end;
  return m >= start || m <= end;
};

export type ScheduleKind =
  | { kind: 'clocked'; times_minutes: number[] }
  | { kind: 'frequency'; every_minutes: number };

export type ScheduleType = 'clocked' | 'frequency';

export interface ScheduleWindow {
  tz: string;
  start_min: number;
  end_min: number;
}

export interface EmailSchedule {
  id: string;
  user_id: string;
  dashboard_id: string;
  subject: string;
  recipient: string;
  schedule: ScheduleKind;
  window: ScheduleWindow;
  created_at: string;
  updated_at: string;
}

export const clockedSlots = (): number[] => {
  const out: number[] = [];
  if (WINDOW_START_MIN <= WINDOW_END_MIN) {
    for (let m = WINDOW_START_MIN; m <= WINDOW_END_MIN; m += FREQ_STEP_MIN) out.push(m);
  } else {
    for (let m = WINDOW_START_MIN; m < DAY_MIN; m += FREQ_STEP_MIN) out.push(m);
    for (let m = 0; m <= WINDOW_END_MIN; m += FREQ_STEP_MIN) out.push(m);
  }
  return out;
};

export const frequencyChoices = (): number[] => {
  const out: number[] = [];
  for (let m = FREQ_STEP_MIN; m <= FREQ_MAX_MIN; m += FREQ_STEP_MIN) {
    out.push(m);
  }
  return out;
};

export const formatMinutes = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHour = hours % 12 === 0 ? 12 : hours % 12;
  return `${displayHour}:${mins.toString().padStart(2, '0')} ${period}`;
};
